import React from 'react';
import { Modal, Button, Table } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import './style.less';

class ModifyDetailModal extends React.Component {
    state = {
        visible: false,
        loading: false,
        data: [],
    }

    show = params => {
        this.setState({
            visible: true,
            searchParams: {
                ...params,
            },
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    loadData = () => {
        this.setState({ loading: true });
        const { searchParams } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.hospital.queryBySsuStructureLogId,
            data: {
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                if (!res.error) {
                    this.setState({
                        loading: false,
                        data: res.logDetailList,
                        employeeCode: res.employeeCode,
                        createUserName: res.createUserName,
                        createUserId: res.createUserId,
                        createTimeShow: res.createTimeShow,
                    });
                }
            }
        }
        $.sendRequest(options)
    }

    updateImgUrl = (src) => {
        this.props.updateImgUrl(src);
    }

    downLoadFile = (id) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({ fileMetaId: id }, null, url);
    }

    getColumns = () => [{
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        width: 85,
    }, {
        title: '更新字段',
        dataIndex: 'ssuModuleStructureDefineName',
        key: 'ssuModuleStructureDefineName',
        width: 125,
    }, {
        title: '更新前',
        dataIndex: 'oldValue',
        key: 'oldValue',
        width: 175,
        render: (text, record) => {
            let result = text;
            if ((record.valueType == 'FLOW_CHART') && text) {
                result = <img style={{ width: 175, border: '1px solid #d1d1d1', cursor: 'pointer' }} src={text} onClick={() => this.updateImgUrl(text)} />
            } else if ((record.valueType == 'ATTACHMENT') && record.oldFileMetaList) {
                result = record.oldFileMetaList.map(i => <p key={i.id}><a onClick={() => this.downLoadFile(i.id)}>{i.name}</a></p> );
            }
            return result;
        }
    }, {
        title: '更新后',
        dataIndex: 'newValue',
        key: 'newValue',
        width: 175,
        render: (text, record) => {
            let result = text;
            if ((record.valueType == 'FLOW_CHART') && text) {
                result = <img style={{ width: 175, border: '1px solid #d1d1d1', cursor: 'pointer' }} src={text} onClick={() => this.updateImgUrl(text)} />
            } else if ((record.valueType == 'ATTACHMENT') && record.newFileMetaList) {
                result = record.newFileMetaList.map(i => <p key={i.id}><a onClick={() => this.downLoadFile(i.id)}>{i.name}</a></p> );
            }
            return result;
        }
    }]
    
    getDataSource = () => {
        const dataSource = [];
        const { data } = this.state;
        data.map((item, index) => {
            dataSource.push({
                index: index + 1,
                ...item,
            });
        });
        return dataSource;
    }

    render() {
        const { visible, loading } = this.state;
        const { createTimeShow = '', createUserName = '', employeeCode = '', createUserId } = this.state;
        //人员ID为0表示系统自动产生（如办事流程引用），更新者显示"自动更新"
        const updateUserShow = createUserId == 0 ? '自动更新' : `${createUserName}(${employeeCode})`;
        return (
            <Modal
                title="更新明细"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal inv-detail"
                wrapClassName="vertical-center-modal"
                width="640px"
                footer={<Button key="back" type="ghost" size="large" onClick={this.hide}>关闭</Button>}
            >
                <div style={{ background:'#fff',padding:'10px 30px' }}>
                    <ul>
                        <li>
                            <div className="filter-bar">
                                <div className="filter-bar-investigation" style={{width:'100%'}}>
                                    <p style={{float:'left',color:"rgba(0, 0, 0, 0.85)"}}>
                                    更新日期 ：{createTimeShow} <span>|</span> 更新者 ：{updateUserShow}
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li >
                            <Table  
                                loading={loading}
                                pagination={false}
                                columns={this.getColumns()}
                                dataSource={this.getDataSource()}
                                rowKey={record => record.index}
                                scroll={{ x: 560 }}
                            />
                        </li>
                    </ul>
                </div>
            </Modal>
        );
    }
}

export default ModifyDetailModal;



// WEBPACK FOOTER //
// ./src/components/common/workFlowTemplate/ModifyDetailModal.js